module.exports = __webpack_public_path__ + "img/lizhishenqing.95664f0c.png";